import React from "react";
import { withRouter } from "react-router-dom";

const NavButton = ({ history, to, disabled, className, children }) => (
  <button
    type='button'
    disabled={disabled}
    onClick={() => { history.push(to) }}
    className={className}
  >{children}</button>
);

export default withRouter(NavButton);
